// Specular CTA rim-light — vanilla port of React Bits <SpecularButton/>.
// The original renders a WebGL SDF shader per button; one GL context per CTA
// would exhaust browser context limits on CTA-heavy pages, so the rim streak
// is a conic-gradient ring (streaks at 90°/270°, rotated via --sb-a) driven by
// the same steering math: pointer-facing light angle, exp smoothing, 250px
// proximity fade, idle sweep. (ponytail: visual approximation, not the shader)
(function () {
  var SEL = '.cta, .cta2, .h2-buynow, .pv-buynow';
  var PROXIMITY = 250, SPEED = 0.35;
  var btns = [];

  function lum(c) {
    var m = c.match(/[\d.]+/g);
    if (!m || m.length < 3) return 0;
    return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255;
  }

  function attach(el) {
    if (el.querySelector('.spec-fx')) return;
    var fx = document.createElement('span');
    fx.className = 'spec-fx';
    fx.setAttribute('aria-hidden', 'true');
    el.appendChild(fx);
    // the rim is absolute; a static host lets it anchor to the viewport (2px page overflow)
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    // dark button = white streak; light button = deep accent streak
    var bright = lum(getComputedStyle(el).backgroundColor) > 0.6;
    el.style.setProperty('--sb-line', bright ? 'var(--deep, #383636)' : '#FFFFFF');
    btns.push({ el: el, angle: 2.4, idle: 2.4, bright: 0, target: null, prox: 0 });
  }
  window.mzSpecularAttach = attach;
  Array.prototype.forEach.call(document.querySelectorAll(SEL), attach);

  var px = null, py = null;
  addEventListener('pointermove', function (e) { px = e.clientX; py = e.clientY; }, { passive: true });

  var last = performance.now();
  function frame(now) {
    requestAnimationFrame(frame);
    var dt = Math.min((now - last) / 1000, 0.05);
    last = now;
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      b.idle += SPEED * dt;
      if (px !== null) {
        var r = b.el.getBoundingClientRect();
        if (!r.width) continue;
        var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        var dx = Math.max(r.left - px, 0, px - r.right);
        var dy = Math.max(r.top - py, 0, py - r.bottom);
        var dist = Math.hypot(dx, dy);
        if (dist === 0) {
          var nx = (px - cx) / (r.width / 2), ny = (cy - py) / (r.height / 2);
          b.target = Math.atan2(2 / r.height, -2 / r.width) + nx * 0.3 + ny * 0.15;
        } else {
          b.target = Math.atan2(cy - py, px - cx);
        }
        var t = Math.max(0, 1 - dist / PROXIMITY);
        b.prox = t * t * (3 - 2 * t);
      }
      var goal = b.target !== null ? b.target : b.idle;
      var diff = ((goal - b.angle + Math.PI * 3) % (Math.PI * 2)) - Math.PI;
      b.angle += diff * (1 - Math.exp(-dt * 7));
      b.bright += (b.prox - b.bright) * (1 - Math.exp(-dt * 8));
      if (b.bright < 0.003) { b.el.style.setProperty('--sb-o', '0'); continue; }
      // css conic 0deg = up/clockwise; math angle = ccw from right → bearing 90-a
      var from = 90 - b.angle * 180 / Math.PI - 90;
      b.el.style.setProperty('--sb-a', from.toFixed(2) + 'deg');
      b.el.style.setProperty('--sb-o', b.bright.toFixed(3));
    }
  }
  requestAnimationFrame(frame);
})();
